import pv from './pv.svg';
import uv from './uv.svg';
import vv from './vv.svg';

export {
    pv, uv, vv
}